import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Button, Card, Table, Form, Spinner } from "react-bootstrap";
import { FaSearch, FaArrowLeft } from "react-icons/fa";
import appConstants from "../constants/appConstants";
import Layout from "../components/Layout";

const AccountTypeSummary = () => {
    const navigate = useNavigate();
    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");
    const [summary, setSummary] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");

    const fetchSummary = async () => {
        if (!startDate || !endDate) {
            setError("Please select a start and end date.");
            return;
        }

        setLoading(true);
        setError("");
        try {
            const token = localStorage.getItem("authToken");
            const response = await axios.post(
                `${appConstants.API_ROOT_URL}get-account-type-summary`,
                { start_date: startDate, end_date: endDate },
                { headers: { Authorization: `Bearer ${token}` } }
            );
            setSummary(response.data.summary);
        } catch (err) {
            setError("Failed to fetch summary. Please try again.");
        }
        setLoading(false);
    };

    return (
        <Layout>
            <Card className="p-4">
                <div className="d-flex justify-content-between align-items-center mb-3">
                    <h3 className="mb-0">Account Summary</h3>
                    <Button variant="secondary" onClick={() => navigate(-1)}>
                        <FaArrowLeft /> Back
                    </Button>
                </div>
                <div className="d-flex gap-3 mb-3">
                    <Form.Control
                        type="date"
                        value={startDate}
                        onChange={(e) => setStartDate(e.target.value)}
                    />
                    <Form.Control
                        type="date"
                        value={endDate}
                        onChange={(e) => setEndDate(e.target.value)}
                    />
                    <Button variant="primary" onClick={fetchSummary} disabled={loading}>
                        {loading ? <Spinner animation="border" size="sm" /> : <FaSearch />} Get Summary
                    </Button>
                </div>
                {error && <p className="text-danger">{error}</p>}
                {summary.length > 0 && (
                    <Table striped bordered hover>
                        <thead>
                            <tr>
                                <th>Account Type</th>
                                <th>Debit Total</th>
                                <th>Credit Total</th>
                                <th>Balance</th>
                            </tr>
                        </thead>
                        <tbody>
                            {summary.map((item, index) => (
                                <tr key={index}>
                                    <td>{item.account_type}</td>
                                    <td>{item.total_debit}</td>
                                    <td>{item.total_credit}</td>
                                    <td>{(item.total_debit - item.total_credit).toFixed(2)}</td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                )}
            </Card>
        </Layout>
    );
};

export default AccountTypeSummary;
